<template>
  <div>
    <el-popover
      ref="popover"
      @show="showPopover = true"
      @hide="showPopover = false"
      v-model="showPopover"
      placement="bottom"
      width="1250px"
      trigger="click"
    >
      <el-input
        :value="selectValue"
        slot="reference"
        placeholder="请选择用户"
        :suffix-icon="showPopover ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
        readonly
      ></el-input>
      <div style="position: relative; height: 25px">
        <i
          @click="showPopover = false"
          class="el-icon-close"
          style="font-size: large; position: absolute; right: 0px"
        ></i>
      </div>
      <el-row :gutter="20">
        <el-col :span="11">
          <span style="font-weight: bold; font-size: 18px; color: var(--fm-primary-color)">
            全部用户
          </span>
          <el-form class="hq-padding-top-10" inline :model="leftSearchData">
            <el-form-item>
              <el-input
                placeholder="账号/姓名"
                clearable
                prefix-icon="el-icon-search"
                v-model="leftSearchData.searchInputValue"
                style="width: 250px"
              >
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="leftChangeAndSearch"
              >
                搜索
              </el-button>
            </el-form-item>
          </el-form>
          <el-table
            :data="
              leftSearchRes && leftSearchRes.data ? leftSearchRes.data : []
            "
            stripe
            ref="leftRefsTable"
            @sort-change="leftSortChange"
            @selection-change="leftHandleSelectionChange"
            max-height="300px"
          >
            <el-table-column
              type="selection"
              :selectable="selectableFun"
              width="55"
            >
            </el-table-column>
            <el-table-column
              prop="phoneNumber"
              label="账号"
              width="100"
              header-align="center"
              align="left"
              sortable="custom"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              min-width="100"
              header-align="center"
              align="left"
              sortable="custom"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="leftSearchRes && leftSearchRes.pageInfo"
            @current-change="leftHandleCurrentChange"
            :current-page="leftSearchRes.pageInfo.page"
            :page-size="leftSearchRes.pageInfo.pageSize"
            layout="total, prev, pager, next "
            :total="leftSearchRes.total"
          >
          </el-pagination>
        </el-col>
        <el-col :span="2">
          <div style="padding-top: 100px">
            <div v-if="leftList.length > 0">已选 {{ leftList.length }}</div>
            <el-button
              type="primary"
              icon="el-icon-right"
              @click="addUser"
              :disabled="!leftList.length || leftList.length < 1"
            ></el-button>
          </div>
          <div style="padding-top: 30px">
            <div v-if="rightList.length > 0">已选 {{ rightList.length }}</div>
            <el-button
              type="primary"
              icon="el-icon-back"
              @click="cancelUser"
              :disabled="!rightList.length || rightList.length < 1"
            ></el-button>
          </div>
        </el-col>
        <el-col :span="11">
          <span style="font-weight: bold; font-size: 18px; color: var(--fm-primary-color)">
            已选用户
          </span>
          <el-form class="hq-padding-top-10" inline :model="rightSearchData">
            <el-form-item>
              <el-input
                placeholder="账号/姓名"
                clearable
                prefix-icon="el-icon-search"
                v-model="rightSearchData.searchInputValue"
                style="width: 250px"
              >
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="rightChangeAndSearch"
              >
                搜索
              </el-button>
            </el-form-item>
          </el-form>
          <el-table
            :data="
              rightSearchRes && rightSearchRes.data ? rightSearchRes.data : []
            "
            stripe
            ref="rightRefsTable"
            @sort-change="rightSortChange"
            @selection-change="rightHandleSelectionChange"
            max-height="300px"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="phoneNumber"
              label="账号"
              width="100"
              header-align="center"
              align="left"
              sortable="custom"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              min-width="100"
              header-align="center"
              align="left"
              sortable="custom"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="rightSearchRes && rightSearchRes.pageInfo"
            @current-change="rightHandleCurrentChange"
            :current-page="rightSearchRes.pageInfo.page"
            :page-size="rightSearchRes.pageInfo.pageSize"
            layout="total, prev, pager, next "
            :total="rightSearchRes.total"
          >
          </el-pagination>
        </el-col>
      </el-row>
    </el-popover>
  </div>
</template>
  
<script>
export default {
  name: "UserTransfer",
  props: {
    value: [Array],
    userList: {
      type: Array,
    },
  },
  watch: {
    value: {
      handler(val) {
        this.selectIdList = this.value || [];
      },
      immediate: true,
    },
    showPopover: {
      handler(val) {
        this.leftSearch(true);
        this.rightSearch(true, { showFailMessage: false });
      },
      immediate: true,
    },
  },
  computed: {
    selectValue() {
      if (this.selectIdList && this.selectIdList.length > 0) {
        if (this.userList) {
          return this.userList.map((d) => d.name).join("、");
        }
        return "共选 " + this.selectIdList.length + " 人";
      }
    },
  },
  data() {
    return {
      selectIdList: [],
      showPopover: false,

      leftSearchData: {
        searchInputValue: null,
      },
      leftSearchParam: {
        quickSearchInfoList: [
          {
            columns: ["phoneNumber", "name"],
            quickSearchValue: null,
          },
        ],
        pageInfo: {
          page: 1,
          pageSize: 20,
        },
        sortInfo: null,
      },
      leftSearchRes: {},
      rightSearchData: {
        searchInputValue: null,
      },
      rightSearchParam: {
        quickSearchInfoList: [
          {
            columns: ["account", "name"],
            quickSearchValue: null,
          },
        ],
        pageInfo: {
          page: 1,
          pageSize: 20,
        },
        sortInfo: null,
      },
      rightSearchRes: {},

      leftList: [],
      rightList: [],
    };
  },
  methods: {
    selectableFun(row, index) {
      return !row.disabled;
    },
    leftSortChange(val) {
      this.leftSearchParam.sortInfo =
        val && val.order
          ? {
              columnName: val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.leftSearch(true, {
        showSuccessMessage: true,
      });
    },
    leftHandleSelectionChange(val) {
      this.leftList = val;
    },
    leftHandleCurrentChange(val) {
      this.leftSearchParam.pageInfo.page = val;
      this.leftSearch(false, {
        showSuccessMessage: true,
      });
    },
    leftChangeAndSearch() {
      this.leftSearchParam.quickSearchInfoList[0].quickSearchValue =
        this.leftSearchData.searchInputValue;
      this.leftSearch(true, {
        showSuccessMessage: true,
      });
    },
    async leftSearch(init, args) {
      if (init) {
        this.leftSearchParam.pageInfo.page = 1;
      }
      let requestRes = await this.$api.user_findPageForSelect(
        this.leftSearchParam,
        args
      );
      if (requestRes && requestRes.success) {
        let list = requestRes.data;
        if (list.length > 0) {
          list = list.map((item) => {
            return {
              ...item,
              disabled: this.selectIdList.indexOf(item.id) > -1,
            };
          });
        }
        this.leftSearchRes = {
          ...requestRes,
          data: list,
        };
        this.$nextTick(() => {
          this.$refs.leftRefsTable.doLayout();
        });
      }
      if (requestRes.pageCount == 0) {
        this.leftSearchRes = null;
      }
    },
    rightSortChange(val) {
      this.rightSearchParam.sortInfo =
        val && val.order
          ? {
              columnName: val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.rightSearch(true, {
        showSuccessMessage: true,
      });
    },
    rightHandleCurrentChange(val) {
      this.rightSearchParam.pageInfo.page = val;
      this.rightSearch(false, {
        showSuccessMessage: true,
      });
    },
    rightHandleSelectionChange(val) {
      this.rightList = val;
    },
    rightChangeAndSearch() {
      this.rightSearchParam.quickSearchInfoList[0].quickSearchValue =
        this.rightSearchData.searchInputValue;
      this.rightSearch(true, {
        showSuccessMessage: true,
      });
    },
    async rightSearch(init, args) {
      if (init) {
        this.rightSearchParam.pageInfo.page = 1;
      }
      this.rightSearchParam.idList = this.selectIdList;
      let requestRes = await this.$api.user_findPageForSelect(
        this.rightSearchParam,
        args
      );
      if (requestRes && requestRes.success) {
        let list = requestRes.data;
        this.rightSearchRes = { ...requestRes, data: list };
        this.$nextTick(() => {
          this.$refs.rightRefsTable.doLayout();
        });
      }
      if (requestRes.pageCount == 0) {
        this.rightSearchRes = null;
      }
    },
    async addUser() {
      this.selectIdList = this.selectIdList.concat(
        this.leftList.map((d) => {
          return d.id;
        })
      );
      this.$emit("input", this.selectIdList);
      this.$emit("addUser", this.leftList);
      this.leftSearch();
      this.rightSearch(true, { showFailMessage: false });
    },
    async cancelUser() {
      let rightIdList = this.rightList.map((d) => {
        return d.id;
      });
      this.selectIdList = this.selectIdList.filter((d) => {
        return rightIdList.indexOf(d) < 0;
      });
      this.$emit("input", this.selectIdList);
      this.$emit("cancelUser", this.rightList);
      this.leftSearch();
      this.rightSearch(true, { showFailMessage: false });
    },
  },
};
</script>
  
  <style>
</style>


// WEBPACK FOOTER //
// src/components/UserTransfer.vue